<template>
    <el-dialog :title="detail.testPaperName" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false"
        width="120rem">
        <div class="top">
            <div class="item" style="color: #8590B3;">
                <p>创建时间：</p>
                <p>{{ detail.createTime }}</p>
            </div>
            <div class="right">
                <div class="right-item">
                    <p>得分:</p>
                    <p>{{ queryTotal }}</p>
                </div>
                <div class="right-item">
                    <p>答对:</p>
                    <p>{{ computedRightSub.right }}</p>
                    <p>题</p>
                </div>
                <div class="right-item">
                    <p>答错:</p>
                    <p>{{ computedRightSub.error }}</p>
                    <p>题</p>
                </div>
                <div class="right-item">
                    <p>正确率:</p>
                    <p>{{ Math.round(computedRightSub.right / (computedRightSub.right + computedRightSub.error) * 100) + '%' }}
                    </p>
                </div>
                <div class="right-item">
                    <p>答题时长:</p>
                    <p>{{ detail.userTestTime == -1 ? '无限制' : secondToHours(detail.userTestTime) }}</p>
                </div>
            </div>
        </div>
        <div class="content-box" id="paper-sub-box">
            <div class="sub-module-item" v-for="(item, index) in detail.questionDetailVOS && detail.questionDetailVOS"
                :key="index">
                <div class="module-top">
                    <p>{{ numberToChinese(item.orderIndex) + '、' }}</p>
                    <p>{{ index }}</p>
                    <p>{{ `（共${item.length || 0}题，每题${item[0] ? item[0].questionScore : 0}分）` }}</p>
                </div>
                <div class="module-content">
                    <img src="" alt="">
                    <div class="content-item" v-for="(el, k) in item && item" :class="{ 'border-none': k == item.length - 1 }"
                        :key="k">
                        <div class="el-top">
                            <div>{{ k + 1 + '.' }}</div>
                            <div v-html="el.questionStem" class="html-box"></div>
                        </div>
                        <div v-if="index == '填空题'">
                            <div v-for="(e, i) in el.questionOptionVOS" :key="i"
                                style="display: flex;margin-top: 2rem;align-items: center;">
                                <div>{{ alphabet[i] + '：' }}</div>
                                <el-input v-model="e.value" disabled style="width: 10rem;"></el-input>
                            </div>
                        </div>
                        <div class="options-box" v-else>
                            <el-radio-group v-model="el.value" disabled v-if="['判断题', '单选题'].includes(index)">
                                <el-radio v-for="(e, i) in el.questionOptionVOS" :key="i" :label="e.id">
                                    <div style="display: flex;">
                                        <div>{{ alphabet[i] + '.' }}</div>
                                        <div v-html="e.content" style="white-space: var(--lineWrap);display: flex;"></div>
                                    </div>
                                </el-radio>
                            </el-radio-group>
                            <el-checkbox-group disabled v-model="el.value" v-else-if="index == '多选题'">
                                <el-checkbox v-for="(e, i) in el.questionOptionVOS" :key="i" :label="e.id">
                                    <div style="display: flex;">
                                        <div>{{ alphabet[i] + '.' }}</div>
                                        <div v-html="e.content" style="white-space: var(--lineWrap);display: flex;"></div>
                                    </div>
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div class="answer-box">
                            <div class="box-item">
                                <p>您的答案：</p>
                                <div style="display: flex;">
                                    <p v-for="(x, y) in getAnswer(el)" :key="y">{{ x + (y < (getAnswer(el).length - 1)
                                        ? '、' : '') }}</p>
                                </div>
                                <p>得：{{ el.score || 0 }}分</p>
                            </div>
                            <div style="display: flex;margin-top: 1rem;">
                                <p class="nowrap">正确答案：</p>
                                <p style="color: #67c23a;" v-for="(x, y) in getTrueAnswer(el)" :key="y">{{
                                    x + (y < (getTrueAnswer(el).length - 1) ? '、' : '') }}</p>
                            </div>
                            <div class="an-item">
                                <p class="nowrap">题目解析：</p>
                                <p style="white-space: var(--lineWrap);" v-html="el.content"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { numberToChinese, secondToHours } from '@/utils/utils';
export default {
    props: ['detail'],
    data() {
        return {
            dialogVisible: false,
            alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
            numberToChinese
        }
    },
    watch: {
        detail() {
            let dom = document.querySelector('#paper-sub-box');
            if (dom) {
                let nodes = dom.getElementsByTagName('img');
                nodes = Array.from(nodes);
                nodes.forEach(item => {
                    item.style.maxWidth = '100%';
                    item.style.height = 'auto';
                    item.style.objectFit = 'cover';
                })
            }
        }
    },
    methods: {
        secondToHours,
        /**通过id过滤出用户选项 */
        getAnswer(data) {
            var answerArr = [];
            if (data.questionType == '填空题') {
                answerArr = data.questionOptionVOS.map(item => {
                    return item.value;
                })
            } else {
                var obj = {};
                data.questionOptionVOS.forEach(item => {
                    obj[item.id] = item;
                })
                if (['单选题'].includes(data.questionType)) {
                    answerArr = [obj[data.value] ? this.alphabet[obj[data.value].orderIndex - 1] : ''];
                } else if (data.questionType == '多选题') {
                    data.value.forEach(item => {
                        answerArr.push(this.alphabet[obj[item].orderIndex - 1]);
                    })
                } else if (data.questionType == '判断题') {
                    answerArr = [obj[data.value] ? obj[data.value].content : ''];
                }
            }
            return answerArr;
        },
        /**通过id过滤出正确答案选项 */
        getTrueAnswer(data) {
            var answerArr = [];
            var obj = {};
            data.questionOptionVOS.forEach(item => {
                obj[item.id] = item;
            })
            if (['多选题', '单选题'].includes(data.questionType)) {
                data.correctAnswer && data.correctAnswer.forEach(item => {
                    answerArr.push(this.alphabet[obj[item].orderIndex - 1]);
                })
            } else if (data.questionType == '判断题') {
                data.correctAnswer && data.correctAnswer.forEach(item => {
                    answerArr.push(obj[item] ? obj[item].content : '')
                })
            } else if (data.questionType == '填空题') {
                answerArr = data.correctAnswer;
            }
            return answerArr;
        }
    },
    computed: {
        /**计算答对答错的题目 */
        computedRightSub() {
            let right = 0;
            let error = 0;
            let questionDetailVOS = this.detail.questionDetailVOS;
            for (let key in questionDetailVOS) {
                questionDetailVOS[key].forEach(item => {
                    if (item.score == item.questionScore) {
                        right++;
                    } else {
                        error++;
                    }
                })
            }
            return {
                right,
                error
            }
        },
        queryTotal() {
            let sum = 0;
            this.detail.userQuestionScoreVOS && this.detail.userQuestionScoreVOS.forEach(item => {
                sum = sum + item.score || 0;
            })
            return sum;
        }
    },
}
</script>

<style lang="less" scoped>
.nowrap {
    white-space: nowrap;
}

/deep/.el-dialog__header {
    display: flex;
    justify-content: flex-start !important;
    font-weight: 700;
    color: #000000;
}

.item {
    display: flex;
}

.right {
    display: flex;

    .right-item {
        display: flex;
        margin-left: 3rem;

        &> :nth-child(1) {
            color: #8590B3;
        }

        &> :nth-child(2) {
            color: #387DFF;
        }

        &> :nth-child(3) {
            color: #8590B3;
        }
    }
}

.top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4rem;
}

.content-box {
    height: 65rem;
    overflow: auto;
}

.module-top {
    height: 6rem;
    background: #f7f9ff;
    border: 1px solid #e8ecef;
    color: #334681;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    padding: 0 2.5rem;
}

.module-content {
    padding: 0 6rem;
    color: #334681;
    border: 1px solid #e8ecef;

    .content-item {
        padding: 3.5rem 0;
        border-bottom: 1px solid #e8ecef;
    }
}

.border-none {
    border-bottom: none !important;
}

.el-top {
    display: flex;
}

.html-box {
    white-space: var(--lineWrap);
}

.options-box {
    margin-top: 1.5rem;
}

/deep/.el-radio-group {
    display: flex;
    flex-direction: column;
}

/deep/.el-radio {
    margin-top: 2rem;
    display: flex;
}

/deep/.el-checkbox-group {
    display: flex;
    flex-direction: column;
}

/deep/.el-checkbox {
    margin-top: 2rem;
}

/deep/.el-input__inner {
    border: 1px solid transparent;
    border-bottom: 1px solid #334681;
    border-radius: 0;
}

.btn-box {
    display: flex;
    padding: 5rem 0;
    display: flex;
    justify-content: center;
}

.el-title {
    font-size: 2rem;
    color: #334681;
    font-weight: 700;
    text-align: center;
}

.el-view {
    color: #387DFF;
    text-align: center;
    margin-top: 2.5rem;
    margin-bottom: 5rem;
    cursor: pointer;
}

.answer-box {
    color: #334681;
    margin-top: 2rem;

    .box-item {
        display: flex;

        &> :nth-child(2) {
            color: var(--blue);
        }

        &> :nth-child(3) {
            margin-left: 1rem;
        }
    }
}

.an-item {
    display: flex;
    color: #334681;
    margin-top: 1rem;
}

/deep/.el-dialog {
    border-radius: 1rem;
}
</style>